module.exports = __webpack_public_path__ + "img/1573862046.9171cd99.jpg";